import { GuardToursQuery } from '@/graphql/generated/operations'
import { getArchivedLabel } from '@/utils/formats'

import { GuardToursRowDataType } from '../types/table'

export const formatTableData = (
  guardTours: GuardToursQuery['guardTours']['edges']
): GuardToursRowDataType[] =>
  guardTours.map((guardTour) => {
    const node = guardTour?.node
    const facility = node?.tourPlan?.facility

    return {
      id: node?.id,
      tourPlanId: node?.tourPlan?.id,
      facilityName: getArchivedLabel(facility?.name, facility?.archived),
      facilityId: node?.tourPlan?.facility?.id,
      // `address` is nullable: a facility without one must not crash the page.
      facilityAddress: node?.tourPlan?.facility?.address?.[0],
      tourPlan: node?.tourPlan?.name,
      guardFullName: node?.guard?.firstName + ' ' + node?.guard?.lastName,
      submittedTime: node?.updatedAt,
      status: node?.status,
    }
  })
